const getHost = (state) => state.getIn(['browser', 'location', 'host']);
export const getIsLocalhost = (state) => getHost(state)?.includes('localhost');
